import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import { API_BASE_URL } from '../../../../../common/utils/commonUrl'
import http from '../../../../../common/utils/http'
import { DOWNLOAD_FILE, UPLOAD_FILE } from '../../../../../common/utils/uploadFileUtil'
import moment from 'moment'
import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);

export default {
  data () {
    return {
      newsList: [],
      newsclassList: [],
      activityList: []
    }
  },
  methods: {
    goToShopptingCard () {
      this.$router.push({
        path: RoutePathConstants.POINTS_MAIL_HOME_PAGE
      })
    },
    goToMemberCenter () {
      this.$router.push({
        path: RoutePathConstants.WX_PERSONAL_CENTER
      })
    },
    goToTestDrive () {
      this.$router.push({
        path: RoutePathConstants.TEST_DRIVE
      })
    },
    gotoVeentDetails (id) {
      this.$router.push({
        path: RoutePathConstants.VEENT_DETAILS,
        query: {
          id: id
        }
      })
    },
    goToPracticalSkillsDetails (id) {
      this.$router.push({
        path: RoutePathConstants.PRACTICAL_SKILLS_DETAILS,
        query: {
          id: id
        }
      })
    },
    goToPageMailService () {
      this.$router.push({
        path: RoutePathConstants.PAGE_MAIL_SERVICE
      })
    },
    goToDiscountDetails () {
      Toast('功能暂未开放');
      // this.$router.push({
      //   path: RoutePathConstants.DISCOUNT_DETAILS
      // });
    },
    goToAnnualInspectionAgency () {
      Toast('功能暂未开放');
      // this.$router.push({
      //   path: RoutePathConstants.ANNUAL_INSPECTION_AGENCY
      // });
    },
    qoToOilCardRecharge () {
      Toast('功能暂未开放');
      // this.$router.push({
      //   path: RoutePathConstants.OIL_CARD_RECHARGE
      // });
    },
    goToFinancialService () {
      Toast('功能暂未开放');
      // this.$router.push({
      //   path: RoutePathConstants.FINANCIAL_SERVICE
      // });
    },
    dateFormat (time) {
      return time ? moment(time).format('YYYY/MM/DD') : ''
    },
    // 获取资讯
    getNewsAndAttachmentPageList (classificationId) {
      http.get(API_BASE_URL + '/api/wxoa/member/memberBasis/getNewsAndAttachmentPageList?pageNum=1&pageSize=20&classificationId=' + classificationId).then(
        res => {
          this.newsList = res.data.data.dataList.map(item => {
            return {
              ...item,
              img: this.getImg(item.codeToFileIds.categoryIcon[0])
            }
          })
        }
      )
    },
    // 获取资讯分类
    getNewsClassificationAndAttachmentPageList () {
      http.get(API_BASE_URL + '/api/wxoa/member/memberBasis/getNewsClassificationAndAttachmentPageList?pageNum=1&pageSize=100').then(
        res => {
          this.newsclassList = res.data.data.dataList
          this.getNewsAndAttachmentPageList(res.data.data.dataList[0].id)
        }
      )
    },
    // 获取活动列表
    getActivityDefinitionAndAttachmentPageList () {
      http.get(API_BASE_URL + '/api/wxoa/member/memberBasis/getActivityDefinitionAndAttachmentPageList?pageNum=1&pageSize=100').then(
        res => {
          this.activityList = res.data.data.dataList.map(item => {
            return {
              ...item,
              img: this.getImg(item.codeToFileIds.categoryIcon[0])
            }
          })
        }
      )
    },
    // 获取图片
    getImg (imgCode) {
      let img = `${DOWNLOAD_FILE}${imgCode}?X-Authorization=${localStorage.getItem('token')}`
      return img
    },
  },

  mounted () {
    this.getNewsClassificationAndAttachmentPageList()
    this.getActivityDefinitionAndAttachmentPageList()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-home-page-new/views/points-mail-home-page-new.js